import { defineComponent as _defineComponent } from 'vue'
import {
  TUIGlobal,
  TUIStore,
  StoreName,
  IConversationModel,
} from "@tencentcloud/chat-uikit-engine";
import { ref } from "../../../../adapter-vue";
import ToolbarItemContainer from "../toolbar-item-container/index.vue";
import EmojiPickerDialog from "./emoji-picker-dialog.vue";

import faceIcon from "../../../../assets/icon/face.png";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: [
  "insertEmoji",
  "dialogShowInH5",
  "dialogCloseInH5",
  "currentComponentID",
  "toggleComponent",
  "sendMessage",
],
  setup(__props, { emit: emits }) {



const isH5 = ref(TUIGlobal.getPlatform() === "h5");
const isPC = ref(TUIGlobal.getPlatform() === "pc");
const currentConversation = ref();
const container = ref();

TUIStore.watch(StoreName.CONV, {
  currentConversation: (conversation: IConversationModel) => {
    currentConversation.value = conversation;
  },
});

const onIconClick = (dialogRef: any) => {
  if (!isH5.value) {
    emits("toggleComponent");
    return;
  }
  emits("dialogShowInH5", dialogRef.value);
};

const onDialogClose = (dialogRef: any) => {
  if (!isH5.value) {
    return;
  }
  emits("dialogCloseInH5", dialogRef.value);
};

const insertEmoji = (emojiObj: Object) => {
  emits("insertEmoji", emojiObj);
};
const sendMessage = () => {
  emits("sendMessage");
};
const onClose = () => {
  container?.value?.toggleDialogDisplay(false);
};

return { __sfc: true,emits, isH5, isPC, currentConversation, container, onIconClick, onDialogClose, insertEmoji, sendMessage, onClose, ToolbarItemContainer, EmojiPickerDialog, faceIcon }
}

})